import {DomainStore} from 'shared/store';
import {makeAutoObservable} from 'mobx';
import {endpoints, types, auth} from 'main/tools';

class SchedulesContainerState {
  store = new DomainStore();
  history;
  interactiveAgent;

  constructor() {
    makeAutoObservable(this, {
      store: false,
      history: false,
      interactiveAgent: false
    });
  }

  receiveProps({history}) {
    this.history = history;
  }

  setInteractiveAgent(agent) {
    this.interactiveAgent = agent;
  }

  get canCreateSchedule() {
    return auth.hasAccess('::MANAGE_TIME_TRACKING');
  }

  async createSchedule() {
    const {model} = await this.store.post(
      endpoints.TIME_TRACKING.SCHEDULES.ALL,
      types.TIME_TRACKING.SCHEDULE
    );

    this.history.push(`/schedules/${model.id}/edit`);
  }

  async removeSchedule(schedule) {
    await this.store.destroy(schedule);
  }
}

export default SchedulesContainerState;
